import { useEffect, useCallback } from "react";

export default function useOnClickOutside(ref, handler, excludedSelector) {
  const memoizedHandler = useCallback(
    (event) => {
      const clickedEl = event.target;

      // Ignore if clicked element matches excluded selector
      if (excludedSelector && clickedEl.closest(excludedSelector)) {
        return;
      }

      // Ignore if clicked inside a Google Autocomplete dropdown
      let element = clickedEl;
      while (element) {
        if (element.classList.contains("pac-container")) {
          return;
        }
        element = element.parentElement;
      }

      // Ignore if clicked inside the specified ignore ID
      if (clickedEl.closest("#ignoreUseOnClickOutside")) {
        return;
      }

      // Ignore if click is inside the referenced element
      if (!ref.current || ref.current.contains(clickedEl)) {
        return;
      }

      handler(event);
    },
    [handler, excludedSelector]
  );

  useEffect(() => {
    const listener = (event) => {
      memoizedHandler(event);
    };

    document.addEventListener("click", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("click", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, memoizedHandler]);
}
